<template>
    <div class="mulit-level-table">
        <vbtTable
        :data="tableData"
        isBigData
        style="width: 100%"
        :height="tableheight"
        v-bind="$attrs"
        @selection-change="handleSelectionChange"
        border>
            <vbt-table-column v-if="config.selectedRow" type="selection" width="40" fixed></vbt-table-column>
            <vbt-table-column v-if="config.index" type="index" width="40" fixed :index="getIndexMethod"></vbt-table-column>
            <tree-column :columns="columnData"></tree-column>
        </vbtTable>
    </div>
</template>
<script>
import treeColumn from './treeColumn.vue';
import { vbtTable, vbtTableColumn } from 'vbt-table';
export default {
    components: { treeColumn, vbtTable, vbtTableColumn },
    props: {
        tableData: {
            type: Array,
            default() {
                return [];
            }
        },
        columnData: {
            type: Array,
            default() {
                return [];
            }
        },
        tableheight: {
            type: [String, Number],
            default() {
                return 300;
            }
        },
        config: {
            type: Object,
            default() {
                return {
                    selectedRow: false,
                    index: false
                };
            }
        },
        indexMethod: {
            type: Number,
            default() {
                return 0;
            }
        }
    },
    data() {
        return {};
    },
    methods: {
        getIndexMethod(index) {
            return this.indexMethod + index + 1;
        },
        handleSelectionChange(data) {
            this.$emit('selection-change', data);
        }
    }
};
</script>
<style lang='less'>
.mulit-level-table {
    .el-table th > .cell {
        white-space: initial;
        text-align: center;
    }
}
</style>